var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-3 gridcard rounded-card mb-5 " },
    [
      _c(
        "v-layout",
        [
          _c("v-text-field", {
            staticClass: "ma-4",
            attrs: {
              name: "busqueda",
              "append-icon": "search",
              label: "Búsqueda.",
              "single-line": "",
              "hide-details": ""
            },
            on: { input: _vm.onFilterTextBoxChanged },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-material",
        staticStyle: {
          width: "100%",
          height: "400px",
          "font-family": "'Asap', sans-serif"
        },
        attrs: {
          columnDefs: _vm.columnDefs,
          rowData: _vm.rowData,
          pagination: true,
          paginationPageSize: "10"
        },
        on: { "grid-ready": _vm.onGridReady }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.showConfirmacion,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: " ¿Desea eliminar el registro permanentemente ? ",
          textoBtnSi: "Eliminar",
          textoBtnNo: "Cancelar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }